module.exports = __webpack_public_path__ + "static/img/3.173353c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/realme/3.png
// module id = it+U
// module chunks = 0